import axios from 'axios';

// Own instance so the visitor's session token and client header are never sent with a public link.
const publicApi = axios.create({
  baseURL: process.env.REACT_APP_API_URL,
  headers: { Accept: 'application/json' }
});

const getSharedDashboard = async token => {
  const { data } = await publicApi.get(`public/dashboards/${token}`);

  return data;
};

const getSharedMetric = async ({ token, id, params }) => {
  const { data } = await publicApi.get(
    `public/dashboards/${token}/metrics/${id}`,
    { params }
  );

  return data;
};

export { getSharedDashboard, getSharedMetric };
